<template>
  <div>
    <h1>Liste des Modules par Utilisateurs - Accès Admin</h1>
    <Autocomplete :placeholder="selectedUser && selectedUser.Label" :options="users.map(u => ({label: u.Label, value: u.UserId}))" @select="selectedUserId=$event"></Autocomplete>
    <div>
      <div v-for="group of modules" :key="group.IdFor">
        {{group.NomGroupe}}
        <ul>
          <li v-for="module of group.Modules" :key="module.Id">
            <label>
              <input v-if="selectedUser"
                     :disabled="!selectedUser.IsAdmin && module.AdminOnly && selectedUserRights.indexOf(module.Id) === -1"
                     type="checkbox"
                     :checked="selectedUserRights.indexOf(module.Id) !== -1"
                     @click="toggleRight($event, module.Id)" />
              {{" " + module.Title}}
              <span v-if="module.IsPublic">(public)</span>
              <span v-if="module.AdminOnly">
                (admin)
                <small v-if="selectedUser && !selectedUser.IsAdmin && selectedUserRights.indexOf(module.Id) !== -1 && !module.IsPublic">Cet utilisateur ne pourra pas accèder au module étant donnée qu'il n'est pas administrateur</small>
              </span>
            </label>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

  import { getAllUsers } from "@/utils/cdm";
  import { getAllUserModuleRights, getModulesInGroups, toggleUserModuleRight, verifyModuleRights } from "@/utils/module";
  import Autocomplete from "@/components/Autocomplete";
  //import { getAllUsers/*, toggleUserModuleRight*/ } from "@/utils/module"

  export default {
    name: "AdminUsers",
    components: { Autocomplete },
    data() {
      return {
        users: [],
        allRights: [],
        modules: [],
        selectedUserId: null
      }
    },
    mounted() {
      // On récupère les utilisateurs
      getAllUsers().then(res => {
        this.users = res.map(u => {
          u.Label = u.UserName + " " + u.UserFirstname + " - " + u.Login;
          return u;
        });
      });

      getModulesInGroups(true).then(res => this.modules = res);

      getAllUserModuleRights().then(res => {
        this.allRights = res
      });
    },
    methods: {
      toggleRight(e, moduleId) {
        e.preventDefault();
        toggleUserModuleRight(this.selectedUserId, moduleId).then(() => {
          getAllUserModuleRights().then(res => this.allRights = res);
        })
      }
    },
    computed: {
      selectedUser() {
        if (this.selectedUserId)
          return this.users.find(u => u.UserId == this.selectedUserId);
        return null
      },
      selectedUserRights() {
        if (this.selectedUserId)
          return this.allRights.filter(r => r.UserId == this.selectedUserId).map(r => r.ModuleId)
        return []
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Admin/AdminUsers.vue